import {get} from 'lodash';


export default {
    props: {
        block: Object,
        siblings: Array
    },

    computed: {
        type() {
            return get(this.block, 'acf_fc_layout');
        },
    },
};